import type { ISharedTranslations } from "@holisto-web/translations";

export const headerMenuLanguagesKeys = {
  english: "header.menu.languages.english",
  spanish: "header.menu.languages.spanish",
  portuguese: "header.menu.languages.portuguese",
  french: "header.menu.languages.french",
  italian: "header.menu.languages.italian",
  german: "header.menu.languages.german",
  polish: "header.menu.languages.polish",
  dutch: "header.menu.languages.dutch",
  finnish: "header.menu.languages.finnish",
  norwegian: "header.menu.languages.norwegian",
  danish: "header.menu.languages.danish",
  swedish: "header.menu.languages.swedish",
} as const satisfies TranslationsKeys<ISharedTranslations, "header.menu.languages.">;
